<div class="app-es-poa-sidebar">
  <div class="app-es-poa-sidebar__header">
    <div class="app-es-poa-sidebar__header-text">
      {{ headerTitle | translate }}
    </div>
    <div class="app-es-poa-sidebar__header-close" (click)="close.emit()">×</div>
  </div>

  <div class="app-es-poa-sidebar__content">
    <div class="app-es-poa-sidebar__content__header">
      <p class="app-es-poa-sidebar__content__header-description" [innerHTML]="'POA_UPLOAD_SIDEBAR.DESCRIPTION' | translate"></p>
      <p class="app-es-poa-sidebar__content__header-cta" [innerHTML]="'POA_UPLOAD_SIDEBAR.CTA' | translate"></p>
    </div>

    <div class="app-es-poa-sidebar__content__body">
      <document-upload-desktop
        [id]="'es-doc-sidebar-poa' + shipmentId"
        [uploadedDocument]="document"
        attachmentName="DOCUMENT_TYPE.POWER_OF_ATTORNEY"
        attachmentHint="LABELS.POWER_OF_ATTORNEY_HINT_NO_LINK"
        [fileExtensionIgnoreList]="fileExtensionIgnoreList"
        [fileMimeIgnoreList]="fileMimeIgnoreList"
        [isLoading]="isLoadingDocUpload"
        [isSimpleStripLayout]="true"
        [isFullErrorHighlight]="true"
        [isHideTag]="true"
        [canRemoveDocuments]="true"
        [canUploadDocuments]="true"
        [isShowDownloadFile]="true"
        [isShowLoader]="false"
        [poaFileUrl]="POA_FILE_URL"
        (upload)="addDocument($event)"
        (remove)="removeDocument()"
        (stateUpdate)="updateDocumentState($event)"
      ></document-upload-desktop>

      <div class="app-es-poa-sidebar__checkbox custom-control custom-checkbox pl-4">
        <input type="checkbox" [formControl]="dontSaveForFutureFilingsControl" class="custom-control-input" id="dontSaveForFutureFilings" />
        <label class="custom-control-label" for="dontSaveForFutureFilings">
          {{ "LABELS.DONT_SAVE_FOR_FUTURE_FILINGS" | translate }}
        </label>
      </div>
    </div>

    <div class="app-es-poa-sidebar__content__footer">
      <button [disabled]="!inputFile" type="button" class="btn btn-primary btn-square mb-5" (click)="onSave()">
        {{ "BUTTON.SAVE" | translate }}
      </button>
    </div>
  </div>
</div>
